import { render, staticRenderFns } from "./IdUser.vue?vue&type=template&id=189e5b16&"
import script from "./IdUser.vue?vue&type=script&lang=js&"
export * from "./IdUser.vue?vue&type=script&lang=js&"
import style0 from "./IdUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports